<template>
    <v-container>
      <v-row>
        <v-col cols="12" md="8">
          <v-card>
            <v-card-title>
              <span class="text-h5">Edit Class Teacher Profile</span>
            </v-card-title>
  
            <v-card-subtitle>
              Update the information below.
            </v-card-subtitle>
  
            <v-card-text>
              <v-form v-model="valid" ref="form" @submit.prevent="submitForm">
  
                <v-select
                v-model="formData.class_id"
                :items="classList"
                item-text="name"
                item-value="id"
                label="Class"
                :item-disabled="isDisabled"
                :rules="[rules.required]"
                required
              />

                <!-- Teacher Name -->
                <v-text-field
                  v-model="formData.name"
                  label="Teacher Name"
                  required
                  :rules="[rules.required]"
                />
  
                <!-- Teacher Email -->
                <v-text-field
                  v-model="formData.email"
                  label="Teacher Email"
                  type="email"
                  required
                  :rules="[rules.required, rules.email]"
                />
  
                <!-- Teacher Password -->
                <v-text-field
                  v-model="formData.password"
                  label="New Password"
                  type="password"
                  required
                  :rules="[rules.required, rules.password]"
                />
  
                <!-- Confirm Password -->
                <v-text-field
                  v-model="formData.password_confirmation"
                  label="Confirm Password"
                  type="password"
                  required
                  :rules="[rules.required, rules.password]"
                />
  
                <!-- Submit -->
                <v-btn :disabled="!valid" color="primary" @click="submitForm">
                  Save Changes
                </v-btn>
  
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'ProfileEdit',
    data() {
      return {
        gradeId: null,
        classList: [],
        valid: false,
        OldClassId:'',
        formData: {
          name: '',
          email: '',
          password: '',
          password_confirmation: '',
          user_id:this.gradeId || '',
          class_id:'',
        },
        rules: {
          required: v => !!v || 'This field is required.',
          email: v => /^[a-zA-Z0-9]+[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || 'Enter a valid email address.',
          password: v => v.length >= 6 || 'Password must be at least 6 characters.',
        },
      };
    },
    mounted() {
    this.gradeId = this.$route.params.id;
    this.formData.user_id = this.gradeId;
    // this.fetchProfile()
  },
    methods: {
      isDisabled(item) {
  // Disable if user exists AND item is NOT currently selected
  const disabled = item.user !== null && item.id !== this.OldClassId;
  return disabled;
},
      async submitForm() {
        if (this.formData.password !== this.formData.password_confirmation) {
          this.$swal('error',"Passwords don't match.");
          return;
        }
  
        try {
          const response = await axios.post('/grade/updateTeacherGrade', this.formData);
          
          if (response.data.status) {
            this.$swal('success','Profile updated successfully!');
            // Optionally, redirect the user after saving the profile.
            this.$router.push({ name: 'list-grade' });
          } else {
            this.$swal('error',response.data.message || 'Failed to update profile.');
          }
        } catch (error) {
          console.error('Error:', error);
          this.$swal('error','An error occurred while updating the profile.');
        }
      },
  
      async fetchProfile() {
        try {
          const user_id = this.$route.params.id;
          const response = await axios.get('/grade-dashboard/panelprofile', {
            params: { user_id: user_id }, // assuming userId is passed in route params
          });
  
          if (response.data.status) {
            // Populate the form data with fetched profile information
            const { user, grade } = response.data.data;
            
            this.formData.name = user.name;
            this.formData.email = user.email;
            this.formData.class_id = grade.id;
            this.OldClassId =  grade.id;
            // You can also pre-fill other form fields as needed
          } else {
            this.$toast.error(response.data.message || 'Failed to fetch profile data.');
          }
        } catch (error) {
          console.error('Error:', error);
          this.$toast.error('An error occurred while fetching the profile data.');
        }
      },
      async getClasses() {
      try {
        const response = await axios.get('grade/getGradesForEdit', {
          params: {
            school_id: localStorage.getItem('user_id')
          }
        });
        this.classList = response.data.data || response.data;
        
      } catch (error) {
        console.error('Failed to fetch classes:', error);
        this.$toast?.error('Failed to load class list');
      }
    }
    },
    created() {
      this.getClasses().then(() => {
    this.fetchProfile(); // only fetch after classes are ready
  });
    },
  };
  </script>
  
  <style scoped>
  .v-card {
    max-width: 600px;
    margin: 20px auto;
  }
  </style>
  